<!-- 检测记录 -->
<template>
    <div class="app-container">
        <el-container direction="vertical">
            <el-row>
                <el-row>
                    <div style="font-size: 32;font-weight: bolder;">检验检查</div>
                </el-row>
                <el-row style="background-color: #d5d5d5;height: 0.5px;width: 100%;margin-top: 20px;" />
            </el-row>

            <el-row style="margin-top: 30px;">

                <el-tabs type="border-card" @tab-click="clickTab">
                    <el-tab-pane label="血糖">
                        <component :is="currentView1" :pInfo="pInfo" v-if="update1"></component>
                    </el-tab-pane>
                    <el-tab-pane label="血压">
                        <component :is="currentView2" :pInfo="pInfo" v-if="update2"></component>
                    </el-tab-pane>
                </el-tabs>
            </el-row>

        </el-container>

    </div>
</template>

<script>
import bloodGlucoseMonitor from "./inspectionRecord/bloodGlucoseMonitor.vue";
import bloodPressureMonitor from "./inspectionRecord/bloodPressureMonitor.vue";

export default {
    components: { bloodGlucoseMonitor, bloodPressureMonitor },
    props: {
        pInfo: {
            typeof: Object,
            default: null
        }
    },
    data() {
        return {
            currentView1: "bloodGlucoseMonitor",
            currentView2: "bloodPressureMonitor",
            update1: true,
            update2: false
        };
    },
    created() { },
    methods: {
        clickTab(targetName) {
            console.log(targetName);
            if (targetName.label == "血糖") {
                this.update1 = true;
                this.update2 = false;
            } else if (targetName.label == "血压") {
                this.update1 = false;
                this.update2 = true;
            }
        }
    }
};
</script>

<style></style>